import * as React from "react";
import classnames from "classnames";
/* empty css                      */
const AppointmentPrice = ({ className, labels, ...rest }) => {
  if (labels.freeIndication) {
    return /* @__PURE__ */ React.createElement(
      "span",
      {
        className: classnames(
          "appointment-price",
          "appointment-price--is-free-indication",
          className
        ),
        ...rest
      },
      labels.freeIndication
    );
  }
  return null;
};
export {
  AppointmentPrice as default
};
//# sourceMappingURL=AppointmentPrice.js.map
